import { render, staticRenderFns } from "./BaseRanking.vue?vue&type=template&id=ada0b61e&scoped=true&"
import script from "./BaseRanking.vue?vue&type=script&lang=js&"
export * from "./BaseRanking.vue?vue&type=script&lang=js&"
import style0 from "./BaseRanking.vue?vue&type=style&index=0&id=ada0b61e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0b61e",
  null
  
)

export default component.exports